<template>
	<div class="StatBar" :class="classes">
		<div class="StatBar-bar" :style="'width:' + percentage + '%'">
			<span class="StatBar-number" :class="percentage > threshold ? '' : 'StatBar-number--outside'">{{ value }}</span>
		</div>
	</div>
</template>
<script>
export default {
	name: 'CloStatBar',
	props: {
		/**
		 * Value to pass as argument to the component
		 */
		value: {
			type: String,
			default: '',
		},
		/**
		 * Color of the component
		 *
		 * */
		color: {
			type: String,
			default: '',
		},
		/**
		 * Percentage required
		 */
		percentage: {
			type: Number,
			required: true,
		},
		/**
		 * To make the background transparent or not
		 *
		 * */
		backgroundTransparent: {
			type: Boolean,
			defautlt: false,
		},
		/**
		 * reverse style for use on dark backgrounds
		 *
		 * */
		reverse: {
			type: Boolean,
			defautlt: false,
		},
		/**
		 * threshold for determining if value is on bar or outside bar
		 *
		 * */
		threshold: {
			type: Number,
			default: 50,
		},
	},
	computed: {
		classes() {
			let classes = [];
			const prefix = 'StatBar--';
			if (this.backgroundTransparent) {
				classes.push(prefix + 'backgroundTransparent');
			}
			if (this.reverse) {
				classes.push(prefix + 'reverse');
			}
			if (this.color.length) {
				classes.push(prefix + this.color);
			}
			return classes.join(' ');
		},
	},
	data() {
		return {};
	},
};
</script>
<style lang="scss">
/* --------------------------------
	Stat Bar styles
-------------------------------- */

.StatBar {
	background-color: $color-neutral-1;
	width: 100%;
	height: $space-md;
	position: relative;
	.StatBar-bar {
		position: relative;
		background-color: $color-primary-3;
		height: 100%;
		width: 0px;
	}
	.StatBar-number {
		position: absolute;
		top: 0;
		right: $space-xs;
		[dir='rtl'] & {
			right: auto;
			left: $space-xs;
		}
		color: $color-white;
		@include text(2);
		&--outside {
			left: calc(100% + #{$space-xs});
			[dir='rtl'] & {
				right: calc(100% + #{$space-xs});
				left: $space-xs;
			}
			color: $color-text;
		}
	}
}

.StatBar--neutralLight {
	.StatBar-bar {
		background-color: $color-neutral-2;
	}
	.StatBar-number {
		color: $color-black;
	}
}

.StatBar--secondary {
	.StatBar-bar {
		background-color: $color-secondary-4;
	}
}

.StatBar--backgroundTransparent {
	background-color: transparent;
}

.StatBar--reverse {
	background-color: $color-neutral-3;
	.StatBar-number {
		&--outside {
			color: $color-white;
		}
	}
}
</style>
